(function(){
    'use strict';
    angular.module('Directives').directive('scrollBottom', function(){
        return {
            restrict: 'A',
            scope: { 
                scrollBottom: "="
            },
            link: function(scope, element) {
                scope.$watchCollection('scrollBottom', function(newValue){
                    if(newValue) {
                        $(element).scrollTop($(element)[0].scrollHeight);
                    }
                });
            }
        };  
    });
})()


// WEBPACK FOOTER //
// ./js/directives/scrollBottom.js